import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { TwoStepFormModalButton } from 'remote-com-shared/components/TwoStepForm';
import { fieldHasContent, transformProperties } from 'remote-com-shared/domains/prismic/helpers';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled from 'styled-components';

import { ToneStyle, CtaButton } from './PartnersSlice';
import BgIllustration from './assets/logos-bg.png';

const Wrapper = styled.section`
  ${fluidProp(['padding-bottom', 'padding-top'], '50px', '95px')};
  text-align: center;
  color: var(--colors-blank);
  z-index: 1;
  position: relative;
  background-image: url(${BgIllustration.src});
  background-size: cover;
  background-position: top;
  font-family: var(--typography-fontBossa);

  ${ToneStyle};
`;

const CtaTitle = styled.div`
  ${({ theme }) => theme.typography.scale3};
  margin: 0 auto;
  max-width: 725px;

  & > * {
    font-size: inherit;
    font-weight: 500;
    line-height: inherit;
    margin: inherit;
  }
`;

export function BottomCtaSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, ctaLabel, ctaLink } = primary;

  const { context } = slice;
  const { tone } = context;

  return (
    <Wrapper $tone={tone}>
      <ContentContainer>
        {fieldHasContent(title) && (
          <CtaTitle>
            <PrismicRichText field={title} />
          </CtaTitle>
        )}
        {ctaLink ? (
          <CtaButton href={ctaLink?.url} target={ctaLink?.target}>
            {ctaLabel || 'Schedule a demo'}
          </CtaButton>
        ) : (
          <TwoStepFormModalButton button={{ as: CtaButton }}>
            {ctaLabel || 'Schedule a demo'}
          </TwoStepFormModalButton>
        )}
      </ContentContainer>
    </Wrapper>
  );
}
